// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dueDateInfoIcon---3Y13v{display:block;pointer-events:none;width:17px;height:17px;background:transparent !important}.dueDateInfoIcon---3Y13v>span{background:transparent}.dueDateInfoIcon---3Y13v>span>svg{background:transparent}\n", ""]);
// Exports
exports.locals = {
	"dueDateInfoIcon": "dueDateInfoIcon---3Y13v"
};
module.exports = exports;
